'use client'
import { PageSettingsProvider } from './PageSettingsContext'
import { usePageSettingsFromRoute } from './usePageSettingsFromRoute'

/**
 * Client component wrapper that automatically generates page settings
 * based on the current route and provides them via context
 */
export const PageSettingsProviderWrapper = ({ children }: { children: React.ReactNode }) => {
  const settings = usePageSettingsFromRoute()
  
  return (
    <PageSettingsProvider settings={settings}>
      {children}
    </PageSettingsProvider>
  )
}

